import styles from "./styles.scss";
import { FC, useCallback, useState } from "react";
import defaultToast from "react-hot-toast";
import clsx from "clsx";
import { Close, DefaultCategory } from "@/assets/icons";
import { Icons } from "./configs";
import { AvatarLoadManager } from "@/components/avatar-load-manager";
import { ToastProps, ToastType } from "@/components/toast/types";

import { TOAST_MESSAGE } from "../constants";

export const Toast: FC<ToastProps> = ({
  message,
  iconUrl,
  toastType,
  messageTitle,
  user,
  toastSettings,
  actionButtonLabel,
  onActionButtonClick,
}) => {
  const [isCustomIconLoadError, setCustomIconLoadError] = useState(false);
  const ToastIcon = Icons[toastType];

  const dataAttrValue = `${TOAST_MESSAGE}-${toastType}`;

  const handleToastClose = useCallback(() => {
    defaultToast.dismiss(toastSettings?.id);
  }, [toastSettings?.id]);

  const handleCustomIconLoadError = () => {
    setCustomIconLoadError(true);
  };

  const renderAcrylicToast = useCallback(() => {
    return (
      <div className={clsx(styles.toastWrapper, styles.acrylic)}>
        <div data-attributes={dataAttrValue} className={styles.toastBody}>
          <div className={styles.toastIconContainer}>
            {user ? (
              <AvatarLoadManager
                name={user.name}
                surname={user.surname}
                sourceUrl={user.avatarUrl}
                size={40}
              />
            ) : (
              <div className={styles.toastIconWithBackground}>
                {!isCustomIconLoadError && iconUrl ? (
                  <img
                    className={styles.toastIcon}
                    alt=""
                    role="presentation"
                    width="31"
                    height="31"
                    src={iconUrl}
                    decoding="async"
                    onError={handleCustomIconLoadError}
                  />
                ) : (
                  <DefaultCategory />
                )}
              </div>
            )}
          </div>

          {Boolean(message) && <p className={styles.toastText}>{message}</p>}
        </div>

        <button
          type="button"
          className={styles.toastCloseButton}
          onClick={handleToastClose}
        >
          <Close />
        </button>
      </div>
    );
  }, [
    handleToastClose,
    iconUrl,
    isCustomIconLoadError,
    message,
    user,
    dataAttrValue,
  ]);

  if (toastType === ToastType.Acrylic) {
    return renderAcrylicToast();
  }

  return (
    <div className={clsx(styles.toastWrapper, styles[toastType])}>
      <div className={styles.toastTypeIcon}>{ToastIcon}</div>

      <div data-attributes={dataAttrValue} className={styles.toastBody}>
        {messageTitle && <p className={styles.toastTitle}>{messageTitle}</p>}
        <p className={styles.toastText}>{message}</p>
      </div>

      <div className={styles.toastButtonsWrapper}>
        {actionButtonLabel && (
          <button
            className={styles.toastActionButton}
            onClick={onActionButtonClick}
          >
            {actionButtonLabel}
          </button>
        )}

        <button className={styles.toastCloseButton} onClick={handleToastClose}>
          <Close />
        </button>
      </div>
    </div>
  );
};
